import React from "react";
import ReactLoading from "react-loading";
import Styles from "@themes/Styles";

interface LoadingSpinnerProps {
    readonly size?: number;
    readonly color?: string;
}
function LoadingSpinner(props: LoadingSpinnerProps) {
    return (
        <ReactLoading
            type={"spokes"}
            color={props.color ?? Styles.lifeatSpecialRed}
            height={props.size ?? 25}
            width={props.size ?? 25}
        />
    );
}

export default LoadingSpinner;
